import { render, staticRenderFns } from "./CanteenIndexConfig.vue?vue&type=template&id=7fd8f1a0&scoped=true&"
import script from "./CanteenIndexConfig.vue?vue&type=script&lang=ts&"
export * from "./CanteenIndexConfig.vue?vue&type=script&lang=ts&"
import style0 from "./CanteenIndexConfig.vue?vue&type=style&index=0&id=7fd8f1a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd8f1a0",
  null
  
)

export default component.exports